import { render } from "./AddressBrowserComponent.vue?vue&type=template&id=38690823"
import script from "./AddressBrowserComponent.vue?vue&type=script&lang=js"
export * from "./AddressBrowserComponent.vue?vue&type=script&lang=js"

import "./AddressBrowserComponent.vue?vue&type=style&index=0&id=38690823&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__